import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=6dfc9aec&scoped=true"
import script from "./AvatarImage.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarImage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AvatarImage.vue?vue&type=style&index=0&id=6dfc9aec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc9aec",
  null
  
)

export default component.exports